import angular from 'angular';

module.exports = angular.module('common.filters.implied-price-percentage-change', [])
.filter('impliedPricePercentageChange', function(impliedPriceCentsFilter) {
  return function(comp) {
    const impliedPrice = impliedPriceCentsFilter(comp);
    return (impliedPrice - comp.listing.price_cents) / comp.listing.price_cents;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/implied-price-percentage-change.js
 **/